import Hero from "./components/Hero.js";
import Benefit from "./components/Benefit.js";
import Testimonial from "./components/Testimonial.js";
import Feature from "./components/Feature.js";
import Info from "./components/Info.js";
import Action from "./components/Action.js";
import Footer from "./components/Footer.js";

function App() {
  return (
    <main className="app min-vh-100">
      <Hero />
      <Benefit />
      <Testimonial />
      <Feature />
      <Info />
      <Action />
      <Footer />
    </main>
  );
}

export default App;
